module.exports = __webpack_public_path__ + "static/media/chargingPerks.9e8f97e4.png";